"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var window_container_api_1 = require("./window-container-api");
var base_window_container_api_1 = require("./base-window-container-api");
var JetApi = /** @class */ (function (_super) {
    __extends(JetApi, _super);
    function JetApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(JetApi.prototype, "type", {
        get: function () {
            return window_container_api_1.WindowContainerApiType.JET;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JetApi.prototype, "JET", {
        get: function () {
            return window.JET;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(JetApi.prototype, "webSocketProtocol", {
        get: function () {
            // In context of figuring out if WebSocket protocol is wss: or ws:
            // facing streaming Reverse Proxy only allowing wss: as WebSocket protocol even though window.localhost.protocol is http:
            // we decided to hardcode WebSocket protocol to wss: if it's running on Eikon container
            // to achieve establishing WebSocket connection on Eikon container
            // accepting that when we launched the app behind Reverse Proxy on other browsers and if the protocol is supposed to be ws: it do not work
            return "wss:";
        },
        enumerable: true,
        configurable: true
    });
    JetApi.prototype.saveStringValue = function (key, value) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.JET.onLoad(function () {
                _this.JET.Archive.put(key, value);
                _this.JET.Archive.save();
                resolve();
            });
        });
    };
    JetApi.prototype.loadStringValue = function (key) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.JET.onLoad(function () {
                resolve(_this.JET.Archive.get(key) || null);
            });
        });
    };
    JetApi.prototype.clearStringValue = function (key) {
        var _this = this;
        return new Promise(function (resolve) {
            return _this.JET.onLoad(function () {
                _this.JET.Archive.put(key, undefined);
                resolve();
            });
        });
    };
    return JetApi;
}(base_window_container_api_1.BaseWindowContainerApi));
exports.JetApi = JetApi;
exports.jetApi = new JetApi();



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/jet-api.js
// module id = 44
// module chunks = 0